import React from 'react';
import PropTypes from 'prop-types';

const Add = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="add" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M10.9631251,10.9631251 L10.9631251,6.03687495 C10.9631251,5.46422473 11.4273498,5 12,5 C12.5726502,5 13.0368749,5.46422473 13.0368749,6.03687495 L13.0368749,10.9631251 L17.9631251,10.9631251 C18.5357753,10.9631251 19,11.4273498 19,12 C19,12.5726502 18.5357753,13.0368749 17.9631251,13.0368749 L13.0368749,13.0368749 L13.0368749,17.9631251 C13.0368749,18.5357753 12.5726502,19 12,19 C11.4273498,19 10.9631251,18.5357753 10.9631251,17.9631251 L10.9631251,13.0368749 L6.03687495,13.0368749 C5.46422473,13.0368749 5,12.5726502 5,12 C5,11.4273498 5.46422473,10.9631251 6.03687495,10.9631251 L10.9631251,10.9631251 Z" id="Combined-Shape" fill={color}></path>
      </g>
    </svg>
  );
}

Add.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Add.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default Add;



// WEBPACK FOOTER //
// ./src/components/Icons/Add.jsx